import { PrismaService } from '@cart/api-data-access';
import { ImageStorageAdapter } from '@cart/api-data-access';

/**
 * Deletes the underlying file (if any) then the ProductImage row itself.
 * This is the one place quota is actually freed — trashing an image
 * (isActive: false) does not call this; only a manual "delete now" or the
 * 30-day auto-purge cron does. Shared by CommerceAdminService.hardDeleteProductImage
 * (manual trigger) and ImageTrashPurgeService (automatic trigger) so the two
 * triggers can't drift out of sync.
 */
export async function purgeProductImage(
  prisma: PrismaService,
  storageAdapter: ImageStorageAdapter,
  image: { id: string; storageKey: string | null }
): Promise<void> {
  if (image.storageKey) {
    await storageAdapter.delete(image.storageKey);
  }
  await prisma.productImage.delete({ where: { id: image.id } });
}
